const SectionLoader = ({ className }: { className?: string }) => {
  return (
    <div className={className}>
      <div className="flex justify-center items-center py-10">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-default"></div>
      </div>
    </div>
  );
};

export default SectionLoader;
